import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import TopCoin from '../../Pages/Coin/TopCoin';
import './TopCoins.css';
import Section from "../Section";
import Heading from '../Heading';
import { ClipLoader } from 'react-spinners';
import ErrorMessage from '../../ui/ErrorMessage';

// Cache object to store API responses
const cache = {};

const TopCoins = () => {
  const [data, setData] = useState({
    topCoins: [],
    topGainers: [],
    trendingAssets: [],
  });
  const [activeTab, setActiveTab] = useState('Top Coins');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const cacheKey = 'coinsData';
      if (cache[cacheKey]) {
        setData(cache[cacheKey]);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          'https://api.coingecko.com/api/v3/coins/markets',
          {
            params: {
              vs_currency: 'usd',
              order: 'market_cap_desc',
              per_page: 50,
              page: 1,
              sparkline: false,
            },
          }
        );

        const raw = response.data;
        const formattedData = {
          topCoins: raw.slice(0, 3),
          topGainers: [...raw].sort((a, b) => b.price_change_percentage_24h - a.price_change_percentage_24h).slice(0, 3),
          trendingAssets: [...raw].sort((a, b) => b.market_cap_change_percentage_24h - a.market_cap_change_percentage_24h).slice(0, 3),
        };

        setData(formattedData);
        cache[cacheKey] = formattedData;
      } catch (err) {
        setError('Failed to fetch crypto data. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const coinsToDisplay =
    activeTab === 'Top Gainers'
      ? data.topGainers
      : activeTab === 'Trending Assets'
      ? data.trendingAssets
      : data.topCoins;

  return (
    <Section id="top-coins">
      <div className="container mx-auto px-4">
        <div className="text-center">          
          <Heading title="Explore Crypto Assets"/>
          <p className="text-white/70 max-w-2xl mx-auto">
            Simply and securely buy, sell, and manage hundreds of cryptocurrencies.
          </p>
        </div>
        <br></br>
        
        <div className="flex justify-center mb-8 flex-wrap gap-4">
          {['Top Coins', 'Top Gainers', 'Trending Assets'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-full border text-sm transition 
                ${
                  activeTab === tab
                    ? 'bg-white text-black font-semibold'
                    : 'border-white/30 text-white hover:bg-white/10'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {loading ? (
          <ClipLoader />
        ) : error ? (
          <ErrorMessage message={error} />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {coinsToDisplay.map((coin) => (
              <Link to={`/coins/${coin.id}`} key={coin.id} className="block hover:opacity-90 transition">
                <TopCoin coin={coin} />
              </Link>
            ))}
          </div>
        )}

        <div className="text-center mt-10">
          <Link to="/coins">
            <button className="px-6 py-3 bg-white text-black text-sm rounded-full hover:bg-gray-200 transition">
              See more Assets
            </button>
          </Link>
        </div>
      </div>
    </Section>
  );
};

export default TopCoins;